'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Strings = require('./Strings');

var _Strings2 = _interopRequireDefault(_Strings);

var _fs = require('fs');

var _fs2 = _interopRequireDefault(_fs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Assert = function () {
    function Assert() {
        (0, _classCallCheck3.default)(this, Assert);
    }

    (0, _createClass3.default)(Assert, null, [{
        key: 'notNull',
        value: function notNull(name, instance) {
            if (instance) {
                return;
            }

            throw new Error('The parameter ' + name + ' can not be null.');
        }
    }, {
        key: 'notEmptyArray',
        value: function notEmptyArray(name, instance) {
            Assert.notNull(name, instance);
            if (instance.length > 0) {
                return;
            }

            throw new Error('The parameter ' + name + ' must be array and can not be empty.');
        }
    }, {
        key: 'notEmpty',
        value: function notEmpty(name, instance) {
            if (_Strings2.default.hasText(instance)) {
                return;
            }

            throw new Error('The parameter ' + name + ' must be string and can not be empty.');
        }
    }, {
        key: 'notExists',
        value: function notExists(instance) {
            if (_fs2.default.existsSync(instance)) {
                return;
            }

            throw new Error('The file ' + instance + ' does not exists.');
        }
    }]);
    return Assert;
}();

exports.default = Assert;
//# sourceMappingURL=Assert.js.map